const BLE_UUID_TYPES = {
    RRP_SERVICE: 'DAEBB240-B041-11E4-9E45-0002A5D5C51B',
    DEVICE_INFO_SERVICE: '180A',
    SCP_CONTROL_POINT: 'e16c6e20-b041-11e4-a4c3-0002a5d5c51b',
    FW_UPGRADE_CONTROL: 'fe272aa0-b041-11e4-87cb-0002a5d5c51b',
    FW_UPGRADE_DATA: '04941060-b042-11e4-8bf6-0002a5d5c51b',
    FW_UPGRADE_STATUS: '15c32c40-b042-11e4-a643-0002a5d5c51b',
    MANUFACTURER_NAME: '00002a24-0000-1000-8000-00805f9b34fb',
    DEVICE_INFORMATION: 'device_information',

    BATTERY_STATUS: 'f8a54120-b041-11e4-9be7-0002a5d5c51b',
    SYSTEM_STATUS: 'ecdfa4c0-b041-11e4-8b67-0002a5d5c51b'
}

export default BLE_UUID_TYPES;